module.exports = {"locales":["af-za","ar-sa","bg-bg","bs-ba","ca-es","cs-cz","da-dk","de-de","dev","el-gr","en-us","es-ar","es-em","es-es","es-us","eu-es","fi-fi","fr-fr","gl-es","he-il","hu-hu","id-id","it-it","ja-jp","ko-kr","nl-nl","no-no","pl-pl","pt-br","pt-pt","ro-ro","ru-ru","sl-si","sq-al","sr-sp","sv-se","tr-tr","uk-ua","vi-vn","zh-cn","zh-tw"]}


//////////////////
// WEBPACK FOOTER
// ./src/res/locales/available.json
// module id = /5ya
// module chunks = 1